const locale = {
    placeholder: 'وقت منتخب کریں',
    rangePlaceholder: ['وقت منتخب کریں', 'آخر وقت'],
};
export default locale;
